var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBarGraph = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 10,
  viewBox: "0 0 14 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9.005 8c.51 0 .93.383.988.883L10 9c0 .552-.456 1-.995 1H.995A.995.995 0 0 1 0 9c0-.552.456-1 .995-1zm3.988-4c.517 0 .942.383 1 .883L14 5c0 .552-.45 1-1.007 1H1.007A1 1 0 0 1 0 5c0-.552.45-1 1.007-1zM5.997 0a1 1 0 0 1 .996.883L7 1c0 .552-.438 1-1.003 1H1.003A1 1 0 0 1 0 1c0-.552.438-1 1.003-1z"
})));
export default SvgBarGraph;